import { render, staticRenderFns } from "./confirmAward.vue?vue&type=template&id=06312d60&"
import script from "./confirmAward.vue?vue&type=script&lang=js&"
export * from "./confirmAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports